import React from 'react'
import dd from '../FakeData/index.json'
import HeadlineSearch from './HeadlineSearch'
import BlogSearch from './BlogSearch'
import HashSearch from './HashSearch'
import SeoHelmet from '../SEOHelmet/SeoHelmet'

function Search({ match }) {
    return (
        <div className="w3l-homeblock2 py-5">
            <SeoHelmet pageName='Search Results' />
            <div className="container pt-md-4 pb-md-5">
                {/* block */}
                <h1 className="category-title mb-3"> All Blogs from {dd[0].name}</h1>
                {/* <p className="mb-md-5 mb-4 max-width">Lorem ipsum dolor sit amet elit. Id quaerat amet ipsum sunt et quos dolorum.</p> */}
                <HeadlineSearch key={`headlineSearch`} query={match.params.query} />
                {/* <p className="mb-md-5 mb-4 max-width">Lorem ipsum dolor sit amet elit. Id quaerat amet ipsum sunt et quos dolorum.</p> */}
                <BlogSearch key={`cateogarySearch`} query={match.params.query} />
                {/* <p className="mb-md-5 mb-4 max-width">Lorem ipsum dolor sit amet elit. Id quaerat amet ipsum sunt et quos dolorum.</p> */}
                <HashSearch key={`hashSearch`} query={match.params.query} />
                {/* <ul className="site-pagination text-center mt-md-5 mt-4">
                    <li><span aria-current="page" className="page-numbers current">1</span></li>
                    <li><a className="page-numbers" href="#page2">2</a></li>
                    <li><a className="page-numbers" href="#page3">3</a></li>
                    <li><span className="page-numbers dots">…</span></li>
                    <li><a className="page-numbers" href="#page7">7</a></li>
                    <li><a className="next page-numbers" href="#next">Next »</a></li>
                </ul> */}
            </div>
        </div>
    )
}

export default Search
